module.exports = __webpack_public_path__ + "img/elipse.c1c4a060.gif";